<template>
  <b-col cols="12" sm="12">
    <b-card class="mx-auto layered box" tile>
      <b-card-title id="txtAlign">
        <p v-html="$t('configDispositivos.msgConfigDisp', {
          0: '<b>' + this.dispositivo.nombre + '</b>',
          1: '<b>' + getModelo() + '</b>',
        })">
        </p>
      </b-card-title>
      <b-form @submit.stop.prevent="guardarConfiguracion">
        <div class="row mb-2">
          <!-- INICIO DE MODO MIXTO-->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-fix')" variant="info" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgMixto')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-fix" :title="$t('configDispositivos.msgModalMixto')" hide-footer>
                    <p class="my-4"> {{ $t("configDispositivos.msgMixto") }} </p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-fix')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoMixto") }}</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaFix" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaFix" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblMovMixto')" label-for="move" style="color: black"
                    class="alineado-titulo-form">
                    <div class="row">
                      <b-col cols="12" sm="9" md="9">
                        <b-form-select v-model="alarma.tiempoFixMovimiento" :options="translateTiempo" required
                          style="color: black">
                        </b-form-select>
                      </b-col>
                      <b-col cols="12" sm="3" md="3">
                        <b-form-input v-model="alarma.horarioFixMovimiento" type="number" min="1" max="255"
                          id="intervalos" required style="color: black; background-color: white">
                        </b-form-input>
                      </b-col>
                    </div>
                  </b-form-group>
                </b-col>
                <b-col cols="12" sm="12" style="margin-top: -16px">
                  <b-form-group :label="$t('configDispositivos.lblEstMixto')" label-for="move" style="color: black"
                    class="alineado-titulo-form">
                    <div class="row">
                      <b-col cols="12" sm="9" md="9">
                        <b-form-select v-model="alarma.tiempoFixEstatico" :options="translateTiempo" required
                          style="color: black">
                        </b-form-select>
                      </b-col>
                      <b-col cols="12" sm="3" md="3">
                        <b-form-input v-model="alarma.horarioFixEstatico" type="number" min="1" max="255"
                          id="intervalos1" required style="color: black; background-color: white">
                        </b-form-input>
                      </b-col>
                    </div>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE MODO STOP AND GO-->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    v-b-tooltip.hover @click="$bvModal.show('bv-modal-stopandgo')"
                    :title="$t('configDispositivos.msgStopGo')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-stopandgo" :title="$t('configDispositivos.msgModalStop')" hide-footer>
                    <p class="my-4 txtJustify" v-html="$t('configDispositivos.msgTextStop', {
                      0: this.$t('configDispositivos.msgApagadoProf'),
                    })">
                    </p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-stopandgo')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoStopGo") }}</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaApagado" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaApagado" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group id="input-group-3" :label="$t('Gral.tipo') + '* :'" style="color: black"
                    class="alineado-titulo-form">
                    <b-form-select v-model="alarma.tipoApagado" :options="translateAlertas" required
                      style="color: black">
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE VELOCIDAD-->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-velocidad')" variant="info" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgTextAlarma')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-velocidad" :title="$t('configDispositivos.msgAlarma')" hide-footer>
                    <p class="my-4"> {{ $t("configDispositivos.msgTextAlarma") }}</p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-velocidad')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("vMonitoreo.velocidad") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaVelocidad" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaVelocidad" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblVelocidad')" label-for="move" style="color: black"
                    class="alineado-titulo-form">
                    <b-form-input v-model="alarma.velocidad" type="number" min="30" max="999" id="intervalos2" required
                      style="color: black; background-color: white">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE CAMBIO DE DIRECCION-->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-direccion')" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgCambDir')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-direccion" :title="$t('configDispositivos.msgCambDir')" hide-footer>
                    <p class="my-4"> {{ $t("configDispositivos.msgTextCabDir") }} </p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-direccion')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoCambDir") }}</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaDireccion" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaDireccion" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('vMonitoreo.angulo') + '* :'" label-for="move" style="color: black"
                    class="alineado-titulo-form">
                    <b-form-input v-model="alarma.anguloDireccion" type="number" min="1" max="360" id="intervalos3"
                      required style="color: black; background-color: white">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE MOVIMIENTO -->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-movimiento')" variant="info" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgTextAlarMov')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-movimiento" :title="$t('configDispositivos.msgAlarMov')" hide-footer>
                    <p class="my-4">{{ $t("configDispositivos.msgTextAlarMov") }}</p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-movimiento')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("vMonitoreo.movimiento") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaMovimiento" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaMovimiento" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblIngRadio')" label-for="move" style="color: black"
                    class="alineado-titulo-form">
                    <b-form-input v-model="alarma.radio" type="number" min="1" max="9999" id="intervalos4" required
                      style="color: black; background-color: white">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE TRABAJAR EN HORARIO ESPECIFICO -->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-trabajar')" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgTextTrabajo')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-trabajar" :title="$t('configDispositivos.modoTrabajo')" hide-footer>
                    <p class="my-4"> {{ $t("configDispositivos.msgTextTrabajo") }} </p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-trabajar')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style> {{ $t("configDispositivos.modoTrabajo") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox id="alarmaTrabajo" v-model="alarma.alarmaTrabajarHorarioEspecifico" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaTrabajarHorarioEspecifico" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblTiempo')" label-for="move" style="color: black"
                    class="alineado-titulo-form">
                    <div class="row">
                      <b-col cols="12" sm="9" md="9">
                        <b-form-select id="tiempoTrabajo" v-model="alarma.tiempoTrabajo"
                          :options="translateTiempoTrabajo" required style="color: black">
                        </b-form-select>
                      </b-col>
                      <b-col v-if="alarma.tiempoTrabajo == 'd'" cols="12" sm="3" md="3">
                        <b-form-input id="horarioTrabajo" v-model="alarma.horarioTrabajar" type="number" min="1"
                          max="30" required style="color: black; background-color: white">
                        </b-form-input>
                      </b-col>
                      <b-col v-else cols="12" sm="3" md="3">
                        <b-form-input id="horarioTrabajo2" v-model="alarma.horarioTrabajar" type="number" min="1"
                          max="999" required style="color: black; background-color: white">
                        </b-form-input>
                      </b-col>
                    </div>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE CONFIGURACION ZONA HORARIA -->
          <b-col class="col-12 col-sm-12 col-sm-4 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-zonaHoraria')" v-b-tooltip.hover
                    :title="$t('configDispositivos.modoZona')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-zonaHoraria" :title="$t('configDispositivos.modoZona')" hide-footer>
                    <p class="my-4" v-html="$t('configDispositivos.msgTextZona')"></p>
                    <b-col cols="12">
                      <img src="../../../assets/images/zonahorariamexico.jpg" class="mb-4" alt="Zona horarias México" />
                      <div class="row">
                        <b-list-group>
                          <b-list-group-item style="background-color: #9dd1f8">
                            {{ $t("configDispositivos.zonaNoroeste") }}
                          </b-list-group-item>
                          <b-list-group-item>Baja California</b-list-group-item>
                        </b-list-group>
                        <b-list-group>
                          <b-list-group-item style="background-color: #e2cea7">
                            {{ $t("configDispositivos.zonaPacifico") }}
                          </b-list-group-item>
                          <b-list-group-item>Baja California Sur</b-list-group-item>
                          <b-list-group-item>Chihuahua</b-list-group-item>
                          <b-list-group-item>Nayarit</b-list-group-item>
                          <b-list-group-item>Sinaloa</b-list-group-item>
                          <b-list-group-item>Sonora</b-list-group-item>
                        </b-list-group>
                        <b-list-group>
                          <b-list-group-item style="background-color: #9dd06b">
                            {{ $t("configDispositivos.zonaSureste") }}
                          </b-list-group-item>
                          <b-list-group-item>Quintana Roo</b-list-group-item>
                        </b-list-group>
                      </div>
                      <br />
                      <b-list-group>
                        <b-list-group-item class="text-light" style="background-color: #668cb1">
                          {{ $t("configDispositivos.zonaCentro") }}
                        </b-list-group-item>
                      </b-list-group>
                      <div class="row">
                        <b-col cols="6">
                          <b-list-group>
                            <b-list-group-item>Aguascalientes</b-list-group-item>
                            <b-list-group-item>Campeche</b-list-group-item>
                            <b-list-group-item>Coahuila</b-list-group-item>
                            <b-list-group-item>Colima</b-list-group-item>
                            <b-list-group-item>Chiapas</b-list-group-item>
                            <b-list-group-item>Distrito Federal</b-list-group-item>
                            <b-list-group-item>Durango</b-list-group-item>
                            <b-list-group-item>Guanajuato</b-list-group-item>
                            <b-list-group-item>Guerrero</b-list-group-item>
                            <b-list-group-item>Hidalgo</b-list-group-item>
                            <b-list-group-item>Jalisco</b-list-group-item>
                            <b-list-group-item>Estado de México</b-list-group-item>
                          </b-list-group>
                        </b-col>
                        <b-col cols="6">
                          <b-list-group>
                            <b-list-group-item>Morelos</b-list-group-item>
                            <b-list-group-item>Nuevo León</b-list-group-item>
                            <b-list-group-item>Oaxaca</b-list-group-item>
                            <b-list-group-item>Puebla</b-list-group-item>
                            <b-list-group-item>Querétaro</b-list-group-item>
                            <b-list-group-item>San Luis Potosí</b-list-group-item>
                            <b-list-group-item>Tabasco</b-list-group-item>
                            <b-list-group-item>Tamaulipas</b-list-group-item>
                            <b-list-group-item>Tlaxcala</b-list-group-item>
                            <b-list-group-item>Veracruz</b-list-group-item>
                            <b-list-group-item>Yucatán</b-list-group-item>
                            <b-list-group-item>Zacatecas</b-list-group-item>
                          </b-list-group>
                        </b-col>
                      </div>
                    </b-col>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-zonaHoraria')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoZona") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="select" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="select" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblZonaHor')" label-for="move" style="color: black"
                    class="alineado-titulo-form">
                    <b-form-select v-model="alarma.zonaHoraria" :options="translateZonaHoraria" required
                      style="color: black">
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE CONFIGURACION SENSIBILIDAD -->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-sensibilidad')" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgModalSens')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-sensibilidad" :title="$t('configDispositivos.modoSens')" hide-footer>
                    <p class="my-4" v-html="$t('configDispositivos.msgTextSens')"></p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-sensibilidad')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoSens") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaSensibilidad" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaSensibilidad" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblSens')" label-for="move" style="color: black"
                    class="alineado-titulo-form">
                    <b-form-select v-model="alarma.nivelSensibilidad" :options="translateSensibilidad" required
                      style="color: black">
                    </b-form-select>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE RASTREO INTELIGENTE -->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-distancia')" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgTextRastreo') + ' ' + $t('configDispositivos.msgTextDesc')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-distancia" :title="$t('configDispositivos.msgModalRastreo')" hide-footer>
                    <p class="my-4"> {{ $t("configDispositivos.msgTextDesc") }}</p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-distancia')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoRastreoIntel") }}</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaDistancia" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.alarmaDistancia" class="row">
                <b-col cols="12" sm="12">
                  <b-form-group :label="$t('configDispositivos.lblDis')" label-for="move" style="color: black"
                    class="alineado-titulo-form">
                    <b-form-input v-model="alarma.distancia" type="number" min="1" max="9999" id="intervalos5" required
                      style="color: black; background-color: white">
                    </b-form-input>
                  </b-form-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE BATERIA BAJA -->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2"
                    @click="$bvModal.show('bv-modal-bateria')" variant="info" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgBateriaBaja', {})">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-bateria" :title="$t('configDispositivos.bateriaBaja')" hide-footer>
                    <p class="my-4">{{ $t("configDispositivos.msgBateriaBaja", {}) }}</p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-bateria')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.bateriaBaja") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.bateriaBaja" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE MODO RASTREO MICROFONO/RASTREADOR -->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-rastreo')" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgHeadMicro')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-rastreo" :title="$t('configDispositivos.msgModalMicro')" hide-footer>
                    <p class="my-4" v-html="$t('configDispositivos.msgTextOnMicro')"></p>
                    <b-form-checkbox v-model="banf" switch size="lg" disabled>
                    </b-form-checkbox>
                    <p class="my-4" v-html="$t('configDispositivos.msgTextOffMicro')"></p>
                    <b-form-checkbox v-model="bant" switch size="lg" disabled>
                    </b-form-checkbox>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-rastreo')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoRastreo") }}</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.modoRastreo" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE ALARMA POR IMPACTO -->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-impacto')" variant="info" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgAlarImpact')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-impacto" :title="$t('configDispositivos.modoAlarma')" hide-footer>
                    <p class="my-4"> {{ $t("configDispositivos.msgAlarImpact") }}</p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-impacto')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style> {{ $t("configDispositivos.modoAlarma") }}:</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.alarmaImpacto" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE CONFIGURACION DE ADMINISTRADOR -->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-admin')" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgTextAdmin')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-admin" :title="$t('configDispositivos.msgModalAdmin')" hide-footer>
                    <p class="my-4">{{ $t("configDispositivos.msgTextAdmin") }}</p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-admin')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoConfAdmin") }}</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.banAdmin" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.banAdmin" class="row">
                <b-col cols="12" sm="12">
                  <div v-if="mensajeError != ''">
                    <b-alert show variant="danger">{{ mensajeError }}</b-alert>
                  </div>
                  <div class="row">
                    <b-col cols="12" sm="12">
                      <label for="“telefono”">{{ $t("Gral.tel") }}</label>
                      <b-form-input id="intervalos6" v-model="alarma.inputAdmin" required :state="phoneState"
                        aria-describedby="input-live-help-telefono input-live-feedback-telefono" autocomplete="off"
                        style="background-color: white">
                      </b-form-input>
                      <b-form-invalid-feedback id="input-live-feedback-telefono">
                        {{ $t("Gral.valExitTelefono") }}
                      </b-form-invalid-feedback>
                    </b-col>
                    <b-col cols="12" sm="12" class="d-flex justify-content-center">
                      <span class="mdi mdi-plus-circle text-dark" @click="agregarAdmin()" :hidden="validaciones()"
                        v-b-tooltip.hover :title="this.$t('Gral.agregar')" style="font-size: 2rem; color: black">
                      </span>
                    </b-col>
                  </div>
                  <b-list-group>
                    <div v-for="n in alarma.listaAdmin" :key="n" class="row">
                      <b-col cols="10" sm="10">
                        <b-list-group-item>{{ n }}</b-list-group-item>
                      </b-col>
                      <b-col cols="2" sm="2">
                        <span class="mdi mdi-close-circle" @click="eliminarAdmin({ n })" v-b-tooltip.hover
                          :title="this.$t('Gral.eliminar')" style="font-size: 2rem; color: black">
                        </span>
                      </b-col>
                    </div>
                  </b-list-group>
                </b-col>
              </div>
            </b-card>
          </b-col>

          <!-- INICIO DE ESTATUS DEL DISPOSITIVO -->
          <b-col class="col-12 col-sm-12 col-md-6 col-lg-4 col-xl-4">
            <b-card class="justify-content-center layered box" bg-variant="light" text-variant="black" align="center"
              header-bg-variant="dark">
              <div class="row">
                <b-col cols="3" class="d-flex justify-content-start align-items-center">
                  <b-btn
                    class="d-flex align-items-center justify-content-center rounded-circle btn btn-info text-light rounded-circle layered2 box2 ancho-icono-boton"
                    @click="$bvModal.show('bv-modal-estatus')" v-b-tooltip.hover
                    :title="$t('configDispositivos.msgModalEstatus')">
                    <em class="fas fa-question"></em>
                  </b-btn>
                  <b-modal id="bv-modal-estatus" :title="$t('configDispositivos.modoEstatus')" hide-footer>
                    <p class="my-4" v-html="$t('configDispositivos.msgTextEstatus')"></p>
                    <b-btn class="mt-3" block @click="$bvModal.hide('bv-modal-estatus')" style="color: white">
                      {{ $t("Gral.cerrar") }}
                    </b-btn>
                  </b-modal>
                </b-col>
                <b-col cols="7" class="d-flex justify-content-center align-items-center">
                  <h5 class="mb-0" style>{{ $t("configDispositivos.modoEstatus") }}</h5>
                </b-col>
                <b-col cols="2" class="d-flex justify-content-end align-items-center">
                  <b-form-checkbox v-model="alarma.switchCheck" switch size="lg">
                  </b-form-checkbox>
                </b-col>
              </div>
              <div v-if="alarma.switchCheck" class="row">
                <b-col cols="12" sm="12">
                  <b-form-textarea id="textarea" :placeholder="$t('Gral.respuesta')" disabled rows="8" max-rows="6">
                  </b-form-textarea>
                </b-col>
                <b-col cols="12" sm="12">
                  <b-btn color="primary" variant="info" class="w-100 text-white" id="check" @click="enviarCheck">
                    {{ $t("Gral.enviar") }}
                  </b-btn>
                </b-col>
              </div>
            </b-card>
          </b-col>
          <!-- FIN DE ESTATUS DEL DISPOSITIVO -->
        </div>
        <div class="row">
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-end">
            <b-btn color="primary" class="mt-2 ancho-boton w-100" style="color: white" id="cancelarConfiguracion"
              @click="cancelarConfiguracion">
              {{ $t("Gral.cancelar") }}
            </b-btn>
          </div>
          <div class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex justify-content-lg-center margin-top-div">
            <b-btn variant="info" type="submit" class="mt-2 ancho-boton text-light w-100" style="color: white"
              id="guardarMarcador">
              {{ $t("Gral.guardar") }}
            </b-btn>
          </div>
          <b-col class="col-12 col-sm-12 col-md-4 col-lg-4 col-xl-4 d-lg-flex margin-top-div">
            <b-btn variant="danger" class="mt-2 ancho-boton text-light w-100" @click="begin()">
              {{ $t("vMonitoreo.msgReset") }}
            </b-btn>
          </b-col>
        </div>
      </b-form>
    </b-card>
  </b-col>
</template>

<script src="js/main.js"></script>
<script>
import { mapState } from "vuex";
import AlertasDataService from "../../../services/AlertasDataService";
import AlarmaSMSDataService from "../../../services/AlarmaSMSDataService";
import AccionesDataService from "../../../services/AccionesDataService";
import Jwt from "../../../services/Jwt";

export default {
  name: "configuracion",
  data() {
    return {
      // alertas: [{
      //     text: "No apagado",
      //     value: null
      // },
      //     "Apagado profundo por sensor de impacto",
      //     "Apagado por el sensor de impacto",
      //     "Dormir por tiempo"
      // ],
      alertas: [
        {
          //Realizar pruebas para verificas que los nombres traducidos no interfieran con los comando enviados a los dispositivos.
          text: "noApagado",
          value: null,
        },
        {
          text: "apagadoProf",
        },
        {
          text: "apagadoImp",
        },
        {
          text: "dormirTiempo",
        },
      ],
      sensibilidad: [
        {
          //Realizar pruebas para verificas que los nombres traducidos no interfieran con los comando enviados a los dispositivos.
          // text: "Deshabilitado",
          text: "deshabilitado",
          value: 0,
        },
        {
          // text: "Primer nivel: Vibración leve una vez",
          text: "valPrimer",
          value: 1,
        },
        {
          // text: "Segundo nivel: Detectar 8 veces la vibración en 2 segundos",
          text: "valSegundo",
          value: 2,
        },
        {
          // text: "Tercer nivel: Detectar 25 veces la vibración en 5 segundos",
          text: "valTercero",
          value: 3,
        },
      ],
      // zonasHorarias: [{
      //     text: "Seleccione una zona horaria",
      //     value: null
      // },
      //     , "-5 (Zona Sureste)",
      //     "-6 (Zona Centro)",
      //     "-7 (Zona Pacífico)",
      //     "-8 (Zona Noroeste)",
      // ],
      zonasHorarias: [
        {
          //Realizar pruebas para verificas que los nombres traducidos no interfieran con los comando enviados a los dispositivos.
          text: "lblZonaHoraria",
          value: null,
        },
        {
          text: "zonaSureste",
        },
        {
          text: "zonaCentro",
        },
        {
          text: "zonaPacifico",
        },
        {
          text: "zonaNoroeste",
        },
      ],
      tiempoTrabajo: [
        {
          // text: "seleccionar medida de tiempo",
          text: "medidaTiempo",
          value: null,
        },
        {
          // text: "Horas",
          text: "horasM",
          value: "h",
        },
        {
          // text: "Minutos",
          text: "minutosM",
          value: "m",
        },
        {
          // text: "Días",
          text: "diasM",
          value: "d",
        },
      ],
      tiempo: [
        {
          // text: "selecionar medida de tiempo",
          text: "medidaTiempo",
          value: null,
        },
        {
          // text: "Horas",
          text: "horasM",
          value: "h",
        },
        {
          // text: "Minutos",
          text: "minutosM",
          value: "m",
        },
        {
          // text: "Segundos",
          text: "segundosM",
          value: "s",
        },
      ],
      select: false,
      selected: null,
      selected2: null,
      alertasTodas: this.obtenerAlertas(),
      alarma: {
        id: 0,
        idDispositivo: null,
        alarmaImpacto: false,
        apagadoProfundo: null,
        modoRastreo: false,
        bateriaBaja: false,
        alarmaDistancia: false,
        distancia: 0,
        alarmaVelocidad: false,
        velocidad: 0,
        alarmaSensibilidad: false,
        nivelSensibilidad: 0,
        alarmaDireccion: false,
        anguloDireccion: 0,
        alarmaMovimiento: false,
        radio: 0,
        alarmaTrabajarHorarioEspecifico: false,
        horarioTrabajar: 0,
        tiempoTrabajo: null,
        dormirTiempo: false,
        tiempoDormir: null,
        alarmaApagado: false,
        tipoApagado: null,
        zonaHoraria: null,
        alarmaFix: false,
        horarioFixMovimiento: 0,
        tiempoFixMovimiento: null,
        horarioFixEstatico: 0,
        tiempoFixEstatico: null,
        banAdmin: false,
        inputAdmin: "",
        admin: [],
        switchCheck: false,
      },
      dispositivo: {
        id: 0,
        nombre: "",
        imei: "",
        modelo: "",
        model: null,
        telefono: "",
        contrasena: "",
        habilitado: false,
      },
      configuraciones: null,
      banderaRegistrado: false,
      configuracionActual: null,
      tiempoN: null,
      listaAdmin: [],
      listaComandos: [],
      p: 0,
      mensajeError: "",
      socketban: sessionStorage.socket,
      banf: false,
      bant: true,
      accion: "",
      usuarioLogueado: JSON.parse(sessionStorage.getItem("usuarioLogueado")),
      listaMensajes: [],
    };
  },
  
  mounted() {
    this.mostrarDatos(this.$route.params);
    this.ObtenerDatos();
    this.$nextTick(() => {
      if (sessionStorage.banConfig == "false") {
        sessionStorage.setItem("banConfig", "true");
        const io = require("socket.io-client"),
          ioClient = io.connect(process.env.VUE_APP_URL_SERVER_SOCKET_ARDUINO);
        ioClient.on("sms", (msg) => {
          var trama = Jwt.jwtDecodeSms(msg);
          var num = "",
            b,
            shock;
          for (var i = 0; i < trama.length; i++) {
            if (trama.substring(i, i + 1) == "|") {
              b = i;
            }
          }
          num = trama.substring(0, b - 1);
          shock = trama.substring(b + 1, trama.length);

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "monitorok!" ||
              trama.substring(b + 1, trama.length - 1) === "monitorok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgMicrofono"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Configuración modo micrófono",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "trackerok!" ||
              trama.substring(b + 1, trama.length - 1) === "trackerok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgRastreo"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Modo rastreo",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "adminok!" ||
              trama.substring(b + 1, trama.length - 1) === "adminok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgAdmin"),
            });
            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Administrador agregado",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "noadminok!" ||
              trama.substring(b + 1, trama.length - 1) === "noadminok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgEliminarAdmin"),
            });
            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Administrador eliminado",
            };

            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "sensitivityok" ||
              trama.substring(b + 1, trama.length - 1) === "sensitivityok!")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgSensibilidad"),
            });
            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Sensibilidad",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "shockok!" ||
              trama.substring(b + 1, trama.length - 1) === "shockok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgAlerta"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alerta impacto",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "noshockok!" ||
              trama.substring(b + 1, trama.length - 1) === "noshockok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgAlertaDes"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma impacto desactivada",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "Distanceok" ||
              trama.substring(b + 1, trama.length - 1) === "Distanceok!")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgConfiguracion"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Distancia",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "speedok!" ||
              trama.substring(b + 1, trama.length - 1) === "speedok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgVelocidad"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma velocidad activada",
            };

            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "nospeedok!" ||
              trama.substring(b + 1, trama.length - 1) === "nospeedok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgVelocidadDes"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma velocidad desactivada",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "lowbatteryoffok!" ||
              trama.substring(b + 1, trama.length - 1) === "lowbatteryoffok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgBatBajaDes"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma batería baja desactivada",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "lowbatteryonok!" ||
              trama.substring(b + 1, trama.length - 1) === "lowbatteryonok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgBatBaja"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma batería baja activada",
            };
            this.guardarAlarma(data);
          }

          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "moveok!" ||
              trama.substring(b + 1, trama.length - 1) === "moveok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgMovimiento"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma movimiento activada",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "nomoveok!" ||
              trama.substring(b + 1, trama.length - 1) === "nomoveok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgMovimientoDes"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Alarma movimiento desactivada",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "distanceok!" ||
              trama.substring(b + 1, trama.length - 1) === "distanceok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgRastreoDistancia"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Rastreo por distancia y tiempo",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) == "beginok!" ||
              trama.substring(b + 1, trama.length - 1) == "beginok")
          ) {
            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }
            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Reinicio de fábrica",
            };
            this.guardarAlarma(data);
            var data = {
              id: this.alarma.id,
              idDispositivo: this.configuracionActual.idDispositivo,
              alarmaImpacto: false,
              apagadoProfundo: null,
              modoRastreo: false,
              bateriaBaja: false,
              alarmaDistancia: false,
              distancia: 0,
              alarmaVelocidad: false,
              velocidad: 0,
              alarmaSensibilidad: false,
              nivelSensibilidad: 0,
              alarmaDireccion: false,
              anguloDireccion: 0,
              alarmaMovimiento: false,
              radio: 0,
              alarmaTrabajarHorarioEspecifico: false,
              horarioTrabajar: 0,
              tiempoTrabajo: null,
              dormirTiempo: false,
              tiempoDormir: null,
              alarmaApagado: false,
              tipoApagado: null,
              zonaHoraria: null,
              alarmaFix: false,
              horarioFixMovimiento: 0,
              tiempoFixMovimiento: null,
              horarioFixEstatico: 0,
              tiempoFixEstatico: null,
              banAdmin: false,
              inputAdmin: null,
              admin: [],
              switchCheck: false,
            };
            sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
            AlarmaSMSDataService.update(data)
              .then(() => {
                const Toast2 = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });
                Toast2.fire({
                  icon: "success",
                  title: this.$t("vMonitoreo.msgReset"),
                  text: this.$t("configDispositivos.msgReinicio"),
                });
                //this.$nextTick();
                this.ObtenerDatos();
                this.alarma.inputAdmin = null;
                this.alarma.listaAdmin = this.listaAdmin;
              })
              .catch(() => {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "error",
                  title: this.$t("configDispositivos.msgErrActConfig"),
                });
              });
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "angleok" ||
              trama.substring(b + 1, trama.length - 1) === "angleok!")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgDireccion"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Cambio de dirección activado",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "sleeptimeok!" ||
              trama.substring(b + 1, trama.length - 1) === "sleeptimeok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.dormirTiempo"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Dormir por tiempo",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "sleepshockok!" ||
              trama.substring(b + 1, trama.length - 1) === "sleepshockok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.apagadoImp"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Apagado por el sensor de impacto",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "sleepdeepshockok!" ||
              trama.substring(b + 1, trama.length - 1) === "sleepdeepshockok" ||
              trama.substring(b + 1, trama.length - 1) === "sleepdeepok!" ||
              trama.substring(b + 1, trama.length - 1) === "sleepdeepok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.apagadoProf"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Apagado profundo",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "sleepoffok!" ||
              trama.substring(b + 1, trama.length - 1) === "sleepoffok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgApagEnc"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "No apagado/Encendido",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "scheduleok!" ||
              trama.substring(b + 1, trama.length - 1) === "scheduleok" ||
              trama.substring(b + 1, trama.length - 1) === "scheworkok!" ||
              trama.substring(b + 1, trama.length - 1) === "scheworkok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.modoTrabajo"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Trabajar en horario específico",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "noscheduleok!" ||
              trama.substring(b + 1, trama.length - 1) === "noscheworkok!" ||
              trama.substring(b + 1, trama.length - 1) === "noscheworkok")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text:
                this.$t("configDispositivos.modoTrabajo") +
                " " +
                this.$t("configDispositivos.lblDes"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Desactivar trabajar en horario",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "timeok" ||
              trama.substring(b + 1, trama.length - 1) === "timeok!")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.modoZona"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Configuración zona horaria y fecha",
            };
            this.guardarAlarma(data);
          }
          if (
            num == this.dispositivo.telefono &&
            (trama.substring(b + 1, trama.length - 1) === "nofixok" ||
              trama.substring(b + 1, trama.length - 1) === "nofixok!")
          ) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              text: this.$t("configDispositivos.msgCancelarEnvio"),
            });

            var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
            var today = new Date();
            var time = "";
            time = today.getHours() + ":" + today.getMinutes();
            if (today.getMinutes() < 10) {
              time = today.getHours() + ":0" + today.getMinutes();
            }

            var data = {
              tipo: "Configuración",
              dispositivo: this.dispositivo,
              descripcionAlerta: this.dispositivo.nombre,
              hora: time + "HRS",
              fecha: dia,
              latitud: 0,
              longitud: 0,
              velocidad: 0.0,
              select: false,
              link: "Apagar abierto, mixto y distancia",
            };
            this.guardarAlarma(data);
          }
        });
      }
    });
  },
  computed: {
    ...mapState(["locale"]),
    translateAlertas() {
      return this.translateOptions(this.alertas);
    },
    translateSensibilidad() {
      return this.translateOptions(this.sensibilidad);
    },
    translateTiempoTrabajo() {
      return this.translateOptions(this.tiempoTrabajo);
    },
    translateTiempo() {
      return this.translateOptions(this.tiempo);
    },
    translateZonaHoraria() {
      return this.translateOptions(this.zonasHorarias);
    },
    phoneState() {
      return this.alarma.inputAdmin.match("^\\d{10}$") ? true : false;
    },
  },
  methods: {
    translateOptions(values) {
      return values.map((option) => {
        if (typeof option === "object" && option.text) {
          return {
            ...option,
            text: this.$t(`configDispositivos.${option.text}`),
          };
        }
      });
    },
    mostrarDatos(datos) {
      this.dispositivo.id = datos.id;
      this.dispositivo.nombre = datos.nombre;
      this.dispositivo.imei = datos.imei;
      this.dispositivo.modelo = datos.modelo;
      this.dispositivo.model = datos.model;
      this.dispositivo.telefono = datos.telefono;
      this.dispositivo.habilitado = datos.habilitado;
      this.dispositivo.contrasena = datos.contrasena;
    },
    ObtenerDatos() {
      AlarmaSMSDataService.getAll()
        .then((response) => {
          this.configuraciones = Jwt.jwtDecode(response.data);
          if (!this.configuraciones.length == 0) {
            for (var i in this.configuraciones) {
              if (
                this.configuraciones[i].idDispositivo == this.dispositivo.id
              ) {
                this.configuracionActual = this.configuraciones[i];
                this.banderaRegistrado = true;
                this.alarma.id = this.configuraciones[i].id;
                this.alarma.idDispositivo =
                  this.configuraciones[i].idDispositivo;
                this.alarma.alarmaImpacto =
                  this.configuraciones[i].alarmaImpacto;
                this.alarma.apagadoProfundo =
                  this.configuraciones[i].apagadoProfundo;
                this.alarma.modoRastreo = this.configuraciones[i].modoRastreo;
                this.alarma.bateriaBaja = this.configuraciones[i].bateriaBaja;
                this.alarma.alarmaDistancia =
                  this.configuraciones[i].alarmaDistancia;
                this.alarma.distancia = this.configuraciones[i].distancia;
                this.alarma.alarmaVelocidad =
                  this.configuraciones[i].alarmaVelocidad;
                this.alarma.velocidad = this.configuraciones[i].velocidad;
                this.alarma.alarmaSensibilidad =
                  this.configuraciones[i].alarmaSensibilidad;
                this.alarma.nivelSensibilidad =
                  this.configuraciones[i].nivelSensibilidad;
                if (this.configuraciones[i].nivelSensibilidad == null) {
                  this.alarma.nivelSensibilidad = null;
                }
                this.alarma.alarmaDireccion =
                  this.configuraciones[i].alarmaDireccion;
                this.alarma.anguloDireccion =
                  this.configuraciones[i].anguloDireccion;
                this.alarma.alarmaMovimiento =
                  this.configuraciones[i].alarmaMovimiento;
                this.alarma.radio = this.configuraciones[i].radio;
                this.alarma.alarmaTrabajarHorarioEspecifico =
                  this.configuraciones[i].alarmaTrabajarHorarioEspecifico;
                this.alarma.horarioTrabajar =
                  this.configuraciones[i].horarioTrabajar;
                this.alarma.tiempoTrabajo =
                  this.configuraciones[i].tiempoTrabajo;
                if (this.configuraciones[i].tiempoTrabajo == null) {
                  this.alarma.tiempoTrabajo = null;
                }
                this.alarma.dormirTiempo = this.configuraciones[i].dormirTiempo;
                this.alarma.tiempoDormir = this.configuraciones[i].tiempoDormir;
                this.alarma.alarmaApagado =
                  this.configuraciones[i].alarmaApagado;
                this.alarma.tipoApagado = this.configuraciones[i].tipoApagado;
                if (this.configuraciones[i].tipoApagado == null) {
                  this.alarma.tipoApagado = null;
                }
                this.alarma.zonaHoraria = this.configuraciones[i].zonaHoraria;
                if (this.configuraciones[i].zonaHoraria == null) {
                  this.alarma.zonaHoraria = null;
                }
                this.alarma.listaAdmin = this.configuraciones[i].listaAdmin;
                this.alarma.alarmaFix = this.configuraciones[i].alarmaFix;
                this.alarma.tiempoFixMovimiento =
                  this.configuraciones[i].tiempoFixMovimiento;
                this.alarma.horarioFixEstatico =
                  this.configuraciones[i].horarioFixEstatico;
                this.alarma.horarioFixMovimiento =
                  this.configuraciones[i].horarioFixMovimiento;
                this.alarma.tiempoFixEstatico =
                  this.configuraciones[i].tiempoFixEstatico;
                if (this.configuraciones[i].alarmaFix == null) {
                  this.alarma.tiempoFixMovimiento = null;
                  this.alarma.tiempoFixEstatico = null;
                }
              }
            }
          } else {
            this.banderaRegistrado = false;
          }
        })
        .catch((e) => {
          const s = "401";
          if (e.toString().includes(s)) {
            this.$router.push({
              path: "/",
            });
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "warning",
              title: this.$t('Gral.msgSesion')
            });
          }
        });
    },
    obtenerAlertas() {
      AlertasDataService.getAll()
        .then((response) => {
          this.alertasTodas = Jwt.jwtDecode(response.data);
        })
        .catch((e) => {
          const s = "401";
          if (e.toString().includes(s)) {
            this.$router.push({
              path: "/",
            });
          }
        });
    },
    guardarAlarma(data) {
      // AlertasDataService.create(data).then(() => {
      //   const Toast = this.$swal.mixin({
      //     toast: true,
      //     position: "top-end",
      //     showConfirmButton: false,
      //     timer: 4000,
      //     timerProgressBar: true,
      //     didOpen: (toast) => {
      //       toast.addEventListener("mouseenter", this.$swal.stopTimer);
      //       toast.addEventListener("mouseleave", this.$swal.resumeTimer);
      //     },
      //   });

      //   Toast.fire({
      //     icon: "success",
      //     title: this.$t("configDispositivos.msgRespuesta"),
      //   });
      // });
    },
    guardarConfiguracion() {
      this.listaComandos = [];
      this.listaMensajes = [];
      this.p = 0;
      if (!this.banderaRegistrado) {
        var data = {
          idDispositivo: this.dispositivo.id,
          alarmaImpacto: this.alarma.alarmaImpacto,
          apagadoProfundo: this.alarma.apagadoProfundo,
          modoRastreo: this.alarma.modoRastreo,
          bateriaBaja: this.alarma.bateriaBaja,
          alarmaDistancia: this.alarma.alarmaDistancia,
          distancia: this.alarma.distancia,
          alarmaVelocidad: this.alarma.alarmaVelocidad,
          velocidad: this.alarma.velocidad,
          alarmaSensibilidad: this.alarma.alarmaSensibilidad,
          nivelSensibilidad: this.alarma.nivelSensibilidad,
          alarmaDireccion: this.alarma.alarmaDireccion,
          anguloDireccion: this.alarma.anguloDireccion,
          alarmaMovimiento: this.alarma.alarmaMovimiento,
          radio: this.alarma.radio,
          alarmaTrabajarHorarioEspecifico:
            this.alarma.alarmaTrabajarHorarioEspecifico,
          horarioTrabajar: this.alarma.horarioTrabajar,
          tiempoTrabajo: this.alarma.tiempoTrabajo,
          dormirTiempo: this.alarma.dormirTiempo,
          tiempoDormir: this.alarma.tiempoDormir,
          alarmaApagado: this.alarma.alarmaApagado,
          tipoApagado: this.alarma.tipoApagado,
          zonaHoraria: this.alarma.zonaHoraria,
          listaAdmin: this.listaAdmin,
          alarmaFix: this.alarma.alarmaFix,
          tiempoFixMovimiento: this.alarma.tiempoFixMovimiento,
          tiempoFixEstatico: this.alarma.tiempoFixEstatico,
          horarioFixMovimiento: this.alarma.horarioFixMovimiento,
          horarioFixEstatico: this.alarma.horarioFixEstatico,
        };

        if (this.alarma.alarmaFix) {
          var comando = "fix";
          var tiempo = "";
          var tiempoEstatico = "";
          if (this.alarma.horarioFixMovimiento < 10) {
            tiempo =
              "00" +
              this.alarma.horarioFixMovimiento +
              this.alarma.tiempoFixMovimiento;
          } else {
            if (this.alarma.horarioFixMovimiento < 100) {
              tiempo =
                "0" +
                this.alarma.horarioFixMovimiento +
                this.alarma.tiempoFixMovimiento;
            } else {
              tiempo =
                this.alarma.horarioFixMovimiento +
                this.alarma.tiempoFixMovimiento;
            }
          }

          if (this.alarma.horarioFixEstatico < 10) {
            tiempoEstatico =
              "00" +
              this.alarma.horarioFixEstatico +
              this.alarma.tiempoFixEstatico;
          } else {
            if (this.alarma.horarioFixEstatico < 100) {
              tiempoEstatico =
                "0" +
                this.alarma.horarioFixEstatico +
                this.alarma.tiempoFixEstatico;
            } else {
              tiempoEstatico =
                this.alarma.horarioFixEstatico + this.alarma.tiempoFixEstatico;
            }
          }
          this.accion =
            "Activó Modo mixto para el dispositivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Tiempo en movimiento: " +
            tiempo +
            ", tiempo estático: " +
            tiempoEstatico;
          tiempo = tiempo + tiempoEstatico + "***n";
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            tiempo +
            this.dispositivo.contrasena;
          this.listaComandos[this.p] = comandoFin;
          this.listaMensajes[this.p] = this.accion;
          this.p++;
        }
        if (this.alarma.alarmaDistancia) {
          if (this.alarma.alarmaDistancia) {
            var distancia = "0000";
            if (this.alarma.distancia < 10 || this.alarma.distancia < 1000) {
              if (this.alarma.distancia < 10) {
                distancia = "000" + this.alarma.distancia;
              } else {
                if (this.alarma.distancia < 100) {
                  distancia = "00" + this.alarma.distancia;
                } else {
                  distancia = "0" + this.alarma.distancia;
                }
              }
            } else {
              distancia = this.alarma.distancia;
            }

            var comando = "distance";
            this.accion =
              "Activó Rastreo inteligente para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono +
              ". Distancia en metros: " +
              this.alarma.distancia;
            this.listaMensajes[this.p] = this.accion;
            var comandoFin =
              this.dispositivo.telefono +
              "," +
              comando +
              this.dispositivo.contrasena +
              " " +
              distancia;
            this.listaComandos[this.p] = comandoFin;
            this.p++;
          } else {
            var comando = "nofix";
            this.accion =
              "Desactivó Rastreo inteligente para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
            this.listaMensajes[this.p] = this.accion;
            var comandoFin =
              this.dispositivo.telefono +
              "," +
              comando +
              this.dispositivo.contrasena;
            this.listaComandos[this.p] = comandoFin;
            this.p++;
          }
        }
        if (this.alarma.alarmaVelocidad) {
          var velocidad = "000",
            espacio = " ";
          if (this.alarma.alarmaVelocidad) {
            if (this.alarma.velocidad < 10 || this.alarma.velocidad < 100) {
              if (this.alarma.velocidad < 10) {
                velocidad = "00" + this.alarma.velocidad;
              } else {
                velocidad = "0" + this.alarma.velocidad;
              }
            } else {
              velocidad = this.alarma.velocidad;
            }
          }
          var comando = "speed";
          this.accion =
            "Activó Velocidad para el dispositivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Velocidad " +
            this.alarma.velocidad +
            " Km/h";
          if (!this.alarma.alarmaVelocidad) {
            comando = "nospeed";
            espacio = "";
            velocidad = "";
            this.accion =
              "Desactivó Velocidad para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            velocidad;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.alarmaSensibilidad) {
          //this.configuracionSensibilidad();
          var comando = "sensitivity";
          var espacio = " ";

          switch (this.alarma.nivelSensibilidad) {
            case 1:
              this.accion =
                "Activó Configuración de sensibilidad para el dispositivo " +
                this.dispositivo.nombre +
                " con número " +
                this.dispositivo.telefono +
                ". Nivel de sensibilidad: Primer nivel";
              break;
            case 2:
              this.accion =
                "Activó Configuración de sensibilidad para el dispositivo " +
                this.dispositivo.nombre +
                " con número " +
                this.dispositivo.telefono +
                ". Nivel de sensibilidad: Segundo nivel";
              break;
            case 3:
              this.accion =
                "Activó Configuración de sensibilidad para el dispositivo " +
                this.dispositivo.nombre +
                " con número " +
                this.dispositivo.telefono +
                ". Nivel de sensibilidad: Tercer nivel";
              break;
            default:
              this.accion =
                "Desactivó Configuración de sensibilidad para el dispositivo " +
                this.dispositivo.nombre +
                " con número " +
                this.dispositivo.telefono;
              break;
          }
          if (this.alarma.alarmaSensibilidad) {
            this.listaMensajes[this.p] = this.accion;
            var comandoFin =
              this.dispositivo.telefono +
              "," +
              comando +
              this.dispositivo.contrasena +
              espacio +
              this.alarma.nivelSensibilidad;
            this.listaComandos[this.p] = comandoFin;
            this.p++;
          }
        }
        if (this.alarma.alarmaDireccion) {
          //Cambio de direccion
          var angulo = "000",
            espacio = " ";
          if (this.alarma.alarmaDireccion) {
            if (
              this.alarma.anguloDireccion < 10 ||
              this.alarma.anguloDireccion < 100
            ) {
              if (this.alarma.anguloDireccion < 10) {
                angulo = "00" + this.alarma.anguloDireccion;
              } else {
                angulo = "0" + this.alarma.anguloDireccion;
              }
            } else {
              angulo = this.alarma.anguloDireccion;
            }
          }
          var comando = "angle";
          this.accion =
            "Activó Cambio de dirección para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Ángulo: " +
            angulo;

          if (angulo == "000")
            this.accion =
              "Desactivó Cambio de dirección para el disposivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;

          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            angulo;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.alarmaMovimiento) {
          var radio = "0000";
          var espacio = " ";
          if (this.alarma.alarmaMovimiento) {
            if (this.alarma.radio < 10 || this.alarma.radio < 1000) {
              if (this.alarma.radio < 10) {
                radio = "000" + this.alarma.radio;
              } else {
                if (this.alarma.radio < 100) {
                  radio = "00" + this.alarma.radio;
                } else {
                  radio = "0" + this.alarma.radio;
                }
              }
            } else {
              radio = this.alarma.radio;
            }
          }
          var comando = "move";
          this.accion =
            "Activó Movimiento para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Radio: " +
            radio;
          if (!this.alarma.alarmaMovimiento) {
            comando = "nomove";
            espacio = "";
            radio = "";
            this.accion =
              "Desactivó Movimiento para el disposivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            radio;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.alarmaTrabajarHorarioEspecifico) {
          //this.trabajoTiempoEspecifico();
          var espacio = " ";
          var comando = "schedule";
          var mhd = "";

          switch (this.alarma.tiempoTrabajo) {
            case "m":
              mhd = " minutos";
              break;
            case "h":
              mhd = " horas";
              break;
            case "d":
              mhd = " días";
              break;
          }
          this.accion =
            "Activó Trabajar en horario específico para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Tiempo: " +
            this.alarma.horarioTrabajar +
            mhd;

          var tiempo = this.alarma.horarioTrabajar + this.alarma.tiempoTrabajo;
          if (!this.alarma.alarmaTrabajarHorarioEspecifico) {
            comando = "noschedule";
            espacio = "";
            tiempo = "";
            this.accion =
              "Desactivó Trabajar en horario específico para el disposivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }

          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            tiempo;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.zonaHoraria) {
          //this.zonaHoraria();
          var comando = "time zone";
          var espacio = " ";
          var zona = this.alarma.zonaHoraria.substring(0, 3);
          this.accion =
            "Modificó la configuración de zona horaria y fecha para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Zona horaria " +
            this.alarma.zonaHoraria;
          this.listaMensajes[this.p] = this.accion;

          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            zona;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.alarmaApagado) {
          var espacio = " ";
          var comando = "sleep";
          var comando2 = "off";
          if (this.alarma.alarmaApagado) {
            if (this.alarma.tipoApagado == "Dormir por tiempo") {
              comando2 = "time";
            }
            if (this.alarma.tipoApagado == "Apagado por el senso de impacto") {
              comando2 = "shock";
            }
            if (
              this.alarma.tipoApagado ==
              "Apagado profundo por sensor de impacto"
            ) {
              comando2 = "deepshock";
            }
          } else {
            this.alarma.tipoApagado = "No apagado";
          }
          this.accion =
            "Activó Modo stop and go para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Tipo " +
            this.alarma.tipoApagado;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            comando2;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.bateriaBaja) {
          var comando = "lowbattery";
          var espacio = " ";
          var en = "on";
          var txt = "A";
          if (!this.alarma.bateriaBaja) {
            en = "off";
            txt = "Desa";
          }
          this.accion =
            txt +
            "ctivó Batería baja para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            en;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.modoRastreo) {
          var comando = "tracker";
          var txt = "A";
          if (!this.alarma.modoRastreo) {
            comando = "monitor";
            txt = "Desa";
          }
          this.accion =
            txt +
            "ctivó Modo de rastreo micrófono/rastreador para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.alarmaImpacto) {
          var comando = "shock";
          var txt = "A";
          if (!this.alarma.alarmaImpacto) {
            comando = "noshock";
            txt = "Desa";
          }
          this.accion =
            txt +
            "ctivó Alarma por impacto para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        setTimeout(
          this.enviarComando(this.listaComandos, this.listaMensajes),
          5000
        );
        sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
        AlarmaSMSDataService.create(data).then(() => {
          this.formMarcador = false;
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: this.$t("configDispositivos.msgConfigExito"),
          });
          this.ObtenerDatos();
        });
      } else {
        //actualizar datos
        this.listaAdmin[0] = "2294365574";
        var data = {
          id: this.alarma.id,
          idDispositivo: this.dispositivo.id,
          alarmaImpacto: this.alarma.alarmaImpacto,
          apagadoProfundo: this.alarma.apagadoProfundo,
          modoRastreo: this.alarma.modoRastreo,
          bateriaBaja: this.alarma.bateriaBaja,
          alarmaDistancia: this.alarma.alarmaDistancia,
          distancia: this.alarma.distancia,
          alarmaVelocidad: this.alarma.alarmaVelocidad,
          velocidad: this.alarma.velocidad,
          alarmaSensibilidad: this.alarma.alarmaSensibilidad,
          nivelSensibilidad: this.alarma.nivelSensibilidad,
          alarmaDireccion: this.alarma.alarmaDireccion,
          anguloDireccion: this.alarma.anguloDireccion,
          alarmaMovimiento: this.alarma.alarmaMovimiento,
          radio: this.alarma.radio,
          alarmaTrabajarHorarioEspecifico:
            this.alarma.alarmaTrabajarHorarioEspecifico,
          horarioTrabajar: this.alarma.horarioTrabajar,
          tiempoTrabajo: this.alarma.tiempoTrabajo,
          dormirTiempo: this.alarma.dormirTiempo,
          tiempoDormir: this.alarma.tiempoDormir,
          alarmaApagado: this.alarma.alarmaApagado,
          tipoApagado: this.alarma.tipoApagado,
          zonaHoraria: this.alarma.zonaHoraria,
          listaAdmin: this.alarma.listaAdmin,
          alarmaFix: this.alarma.alarmaFix,
          tiempoFixMovimiento: this.alarma.tiempoFixMovimiento,
          tiempoFixEstatico: this.alarma.tiempoFixEstatico,
          horarioFixMovimiento: this.alarma.horarioFixMovimiento,
          horarioFixEstatico: this.alarma.horarioFixEstatico,
        };
        if (
          this.alarma.alarmaFix != this.configuracionActual.alarmaFix ||
          this.alarma.tiempoFixMovimiento !=
            this.configuracionActual.tiempoFixMovimiento ||
          this.alarma.horarioFixMovimiento !=
            this.configuracionActual.horarioFixMovimiento ||
          this.alarma.tiempoFixEstatico !=
            this.configuracionActual.tiempoFixEstatico ||
          this.alarma.horarioFixEstatico !=
            this.configuracionActual.horarioFixEstatico
        ) {
          //this.alarmaDistancia();
          if (this.alarma.alarmaFix) {
            var comando = "fix";
            var tiempo = "";
            var tiempoEstatico = "";
            if (this.alarma.horarioFixMovimiento < 10) {
              tiempo =
                "00" +
                this.alarma.horarioFixMovimiento +
                this.alarma.tiempoFixMovimiento;
            } else {
              if (this.alarma.horarioFixMovimiento < 100) {
                tiempo =
                  "0" +
                  this.alarma.horarioFixMovimiento +
                  this.alarma.tiempoFixMovimiento;
              } else {
                tiempo =
                  this.alarma.horarioFixMovimiento +
                  this.alarma.tiempoFixMovimiento;
              }
            }
            if (this.alarma.horarioFixEstatico < 10) {
              tiempoEstatico =
                "00" +
                this.alarma.horarioFixEstatico +
                this.alarma.tiempoFixEstatico;
            } else {
              if (this.alarma.horarioFixEstatico < 100) {
                tiempoEstatico =
                  "0" +
                  this.alarma.horarioFixEstatico +
                  this.alarma.tiempoFixEstatico;
              } else {
                tiempoEstatico =
                  this.alarma.horarioFixEstatico +
                  this.alarma.tiempoFixEstatico;
              }
            }
            this.accion =
              "Activó Modo mixto para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono +
              ". Tiempo en movimiento: " +
              tiempo +
              ", tiempo estático: " +
              tiempoEstatico;
            tiempo = tiempo + tiempoEstatico + "***n";
            if (!this.alarma.alarmaFix) {
              comando = "nofix";
              tiempo = "";
            }

            this.listaMensajes[this.p] = this.accion;

            var comandoFin =
              this.dispositivo.telefono +
              "," +
              comando +
              tiempo +
              this.dispositivo.contrasena;
            this.listaComandos[this.p] = comandoFin;
            this.p++;
          } else {
            this.accion =
              "Desactivó Modo mixto para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
            this.listaMensajes[this.p] = this.accion;

            var comando = "nofix";
            var comandoFin =
              this.dispositivo.telefono +
              "," +
              comando +
              this.dispositivo.contrasena;
            this.listaComandos[this.p] = comandoFin;
            this.p++;
          }
        }
        if (
          this.alarma.alarmaDistancia !=
            this.configuracionActual.alarmaDistancia ||
          this.alarma.distancia != this.configuracionActual.distancia
        ) {
          if (this.alarma.alarmaDistancia) {
            var distancia = "0000";
            if (this.alarma.distancia < 10 || this.alarma.distancia < 1000) {
              if (this.alarma.distancia < 10) {
                distancia = "000" + this.alarma.distancia;
              } else {
                if (this.alarma.distancia < 100) {
                  distancia = "00" + this.alarma.distancia;
                } else {
                  distancia = "0" + this.alarma.distancia;
                }
              }
            } else {
              distancia = this.alarma.distancia;
            }

            var comando = "distance";
            this.accion =
              "Activó Rastreo inteligente para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono +
              ". Distancia en metros: " +
              this.alarma.distancia;
            this.listaMensajes[this.p] = this.accion;
            var comandoFin =
              this.dispositivo.telefono +
              "," +
              comando +
              this.dispositivo.contrasena +
              " " +
              distancia;
            this.listaComandos[this.p] = comandoFin;
            this.p++;
          } else {
            var comando = "nofix";
            this.accion =
              "Desactivó Rastreo inteligente para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
            this.listaMensajes[this.p] = this.accion;
            var comandoFin =
              this.dispositivo.telefono +
              "," +
              comando +
              this.dispositivo.contrasena;
            this.listaComandos[this.p] = comandoFin;
            this.p++;
          }
        }
        if (
          this.alarma.alarmaVelocidad !=
            this.configuracionActual.alarmaVelocidad ||
          this.alarma.velocidad != this.configuracionActual.velocidad
        ) {
          var velocidad = "000",
            espacio = " ";
          if (this.alarma.alarmaVelocidad) {
            if (this.alarma.velocidad < 10 || this.alarma.velocidad < 100) {
              if (this.alarma.velocidad < 10) {
                velocidad = "00" + this.alarma.velocidad;
              } else {
                velocidad = "0" + this.alarma.velocidad;
              }
            } else {
              velocidad = this.alarma.velocidad;
            }
          }
          var comando = "speed";
          this.accion =
            "Activó Velocidad para el dispositivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Velocidad " +
            this.alarma.velocidad +
            " Km/h";
          if (!this.alarma.alarmaVelocidad) {
            comando = "nospeed";
            espacio = "";
            velocidad = "";
            this.accion =
              "Desactivó Velocidad para el dispositivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            velocidad;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (
          this.alarma.alarmaSensibilidad !=
            this.configuracionActual.alarmaSensibilidad ||
          this.alarma.nivelSensibilidad !=
            this.configuracionActual.nivelSensibilidad
        ) {
          var comando = "sensitivity";
          var espacio = " ";

          switch (this.alarma.nivelSensibilidad) {
            case 1:
              this.accion =
                "Activó Configuración de sensibilidad para el dispositivo " +
                this.dispositivo.nombre +
                " con número " +
                this.dispositivo.telefono +
                ". Nivel de sensibilidad: Primer nivel";
              break;
            case 2:
              this.accion =
                "Activó Configuración de sensibilidad para el dispositivo " +
                this.dispositivo.nombre +
                " con número " +
                this.dispositivo.telefono +
                ". Nivel de sensibilidad: Segundo nivel";
              break;
            case 3:
              this.accion =
                "Activó Configuración de sensibilidad para el dispositivo " +
                this.dispositivo.nombre +
                " con número " +
                this.dispositivo.telefono +
                ". Nivel de sensibilidad: Tercer nivel";
              break;
            default:
              this.accion =
                "Desactivó Configuración de sensibilidad para el dispositivo " +
                this.dispositivo.nombre +
                " con número " +
                this.dispositivo.telefono;
              break;
          }

          if (this.alarma.alarmaSensibilidad) {
            this.listaMensajes[this.p] = this.accion;
            var comandoFin =
              this.dispositivo.telefono +
              "," +
              comando +
              this.dispositivo.contrasena +
              espacio +
              this.alarma.nivelSensibilidad;
            this.listaComandos[this.p] = comandoFin;
            this.p++;
          }
        }
        if (
          this.alarma.alarmaDireccion !=
            this.configuracionActual.alarmaDireccion ||
          this.alarma.anguloDireccion !=
            this.configuracionActual.anguloDireccion
        ) {
          var angulo = "000",
            espacio = " ";
          if (this.alarma.alarmaDireccion) {
            if (
              this.alarma.anguloDireccion < 10 ||
              this.alarma.anguloDireccion < 100
            ) {
              if (this.alarma.anguloDireccion < 10) {
                angulo = "00" + this.alarma.anguloDireccion;
              } else {
                angulo = "0" + this.alarma.anguloDireccion;
              }
            } else {
              angulo = this.alarma.anguloDireccion;
            }
          }
          var comando = "angle";
          this.accion =
            "Activó Cambio de dirección para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Ángulo: " +
            angulo;

          if (angulo == "000")
            this.accion =
              "Desactivó Cambio de dirección para el disposivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;

          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            angulo;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (
          this.alarma.alarmaMovimiento !=
            this.configuracionActual.alarmaMovimiento ||
          this.alarma.radio != this.configuracionActual.radio
        ) {
          var radio = "0000";
          var espacio = " ";
          if (this.alarma.alarmaMovimiento) {
            if (this.alarma.radio < 10 || this.alarma.radio < 1000) {
              if (this.alarma.radio < 10) {
                radio = "000" + this.alarma.radio;
              } else {
                if (this.alarma.radio < 100) {
                  radio = "00" + this.alarma.radio;
                } else {
                  radio = "0" + this.alarma.radio;
                }
              }
            } else {
              radio = this.alarma.radio;
            }
          }
          var comando = "move";
          this.accion =
            "Activó Movimiento para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Radio: " +
            radio;
          if (!this.alarma.alarmaMovimiento) {
            comando = "nomove";
            espacio = "";
            radio = "";
            this.accion =
              "Desactivó Movimiento para el disposivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            radio;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (
          this.alarma.alarmaTrabajarHorarioEspecifico !=
            this.configuracionActual.alarmaTrabajarHorarioEspecifico ||
          this.alarma.horarioTrabajar !=
            this.configuracionActual.horarioTrabajar ||
          this.alarma.tiempoTrabajo != this.configuracionActual.tiempoTrabajo
        ) {
          var espacio = " ";
          var comando = "schedule";
          var mhd = "";

          switch (this.alarma.tiempoTrabajo) {
            case "m":
              mhd = " minutos";
              break;
            case "h":
              mhd = " horas";
              break;
            case "d":
              mhd = " días";
              break;
          }
          this.accion =
            "Activó Trabajar en horario específico para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Tiempo: " +
            this.alarma.horarioTrabajar +
            mhd;

          var tiempo = this.alarma.horarioTrabajar + this.alarma.tiempoTrabajo;
          if (!this.alarma.alarmaTrabajarHorarioEspecifico) {
            comando = "noschedule";
            espacio = "";
            tiempo = "";
            this.accion =
              "Desactivó Trabajar en horario específico para el disposivo " +
              this.dispositivo.nombre +
              " con número " +
              this.dispositivo.telefono;
          }
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            tiempo;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.zonaHoraria != this.configuracionActual.zonaHoraria) {
          var comando = "time zone";
          var espacio = " ";
          var zona = this.alarma.zonaHoraria.substring(0, 3);
          this.accion =
            "Modificó la configuración de zona horaria y fecha para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Zona horaria " +
            this.alarma.zonaHoraria;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            zona;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (
          this.alarma.alarmaApagado != this.configuracionActual.alarmaApagado ||
          this.alarma.tipoApagado != this.configuracionActual.tipoApagado
        ) {
          //MODO STOP AND GO
          var espacio = " ";
          var comando = "sleep";
          var comando2 = "off";
          if (this.alarma.alarmaApagado) {
            if (this.alarma.tipoApagado == "Dormir por tiempo") {
              comando2 = "time";
            }
            if (this.alarma.tipoApagado == "Apagado por el sensor de impacto") {
              comando2 = "shock";
            }
            if (
              this.alarma.tipoApagado ==
              "Apagado profundo por sensor de impacto"
            ) {
              comando2 = "deepshock";
            }
          } else {
            this.alarma.tipoApagado = "No apagado";
          }
          this.accion =
            "Activó Modo stop and go para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono +
            ". Tipo " +
            this.alarma.tipoApagado;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            comando2;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.bateriaBaja != this.configuracionActual.bateriaBaja) {
          var comando = "lowbattery";
          var espacio = " ";
          var en = "on";
          var txt = "A";
          if (!this.alarma.bateriaBaja) {
            en = "off";
            txt = "Desa";
          }
          this.accion =
            txt +
            "ctivó Batería baja para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena +
            espacio +
            en;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (this.alarma.modoRastreo != this.configuracionActual.modoRastreo) {
          //Modo de rastreo micrófono/rastreador
          var comando = "tracker";
          var txt = "A";
          if (!this.alarma.modoRastreo) {
            comando = "monitor";
            txt = "Desa";
          }
          this.accion =
            txt +
            "ctivó Modo de rastreo micrófono/rastreador para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }
        if (
          this.alarma.alarmaImpacto != this.configuracionActual.alarmaImpacto
        ) {
          var comando = "shock";
          var txt = "A";
          if (!this.alarma.alarmaImpacto) {
            comando = "noshock";
            txt = "Desa";
          }
          this.accion =
            txt +
            "ctivó Alarma por impacto para el disposivo " +
            this.dispositivo.nombre +
            " con número " +
            this.dispositivo.telefono;
          this.listaMensajes[this.p] = this.accion;
          var comandoFin =
            this.dispositivo.telefono +
            "," +
            comando +
            this.dispositivo.contrasena;
          this.listaComandos[this.p] = comandoFin;
          this.p++;
        }

        if (this.listaComandos != []) {
          var ban = this.listaComandos % 2;
          for (var i = 0; i < this.listaComandos.length; i++) {
            var listaComandos = [];
            var listaMensajes = [];
            if ((ban = 1)) {
              listaComandos[0] = this.listaComandos[i];
              listaMensajes[0] = this.listaMensajes[i];
              ban = 0;
            } else {
              listaComandos[0] = this.listaComandos[i];
              listaComandos[1] = this.listaComandos[i + 1];
              listaMensajes[0] = this.listaMensajes[i];
              listaMensajes[1] = this.listaMensajes[i + 1];
              i++;
            }
            this.enviarComando(listaComandos, listaMensajes);
          }
        }
        sessionStorage.setItem("idAlarmaSMS", this.alarma.id);

        AlarmaSMSDataService.update(data).then(() => {
          this.formMarcador = false;
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: this.$t("configDispositivos.msgConfigExito"),
          });
          this.ObtenerDatos();
        });
      }
      this.ObtenerDatos();
    },
    cancelarConfiguracion() {
      this.$router.push({
        path: "/monitoreo",
      });
    },
    begin() {
      this.$swal({
        text: this.$t("vMonitoreo.msgConfiReset"),
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "gray",
        confirmButtonText: this.$t("Gral.aceptar"),
        cancelButtonText: this.$t("Gral.cancelar"),
        iconColor: "red",
        reverseButtons: true,
      }).then((result) => {
        if (result.isConfirmed) {
          let txt = "IMEI"; //Texto para concatenar con el dato IMEI/Id
          let comando = "";
          switch (this.dispositivo.modelo) {
            case "TKSTAR":
              txt = "Id";
              comando = "begin" + this.dispositivo.contrasena;
              break;

            case "TK108":
              txt = "IMEI";
              comando = "adminpassword13142324";
              break;
          }
          AlarmaSMSDataService.enviar(this.dispositivo.telefono + "," + comando)
            .then((response) => {
              if (response.status == 200) {
                this.accion =
                  "Reinicio de fábrica a " +
                  this.dispositivo.nombre +
                  " con " +
                  txt +
                  " " +
                  this.dispositivo.imei;
                this.registrarAccion();
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "success",
                  title: this.$t("vMonitoreo.msgReset"),
                  text: this.$t("vMonitoreo.msgTiempoResp"),
                });
                var dia = new Date().toJSON().slice(0, 10).replace(/-/g, "/");
                var today = new Date();
                var time = "";
                time = today.getHours() + ":" + today.getMinutes();
                if (today.getMinutes() < 10) {
                  time = today.getHours() + ":0" + today.getMinutes();
                }
              } else {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "error",
                  title: this.$t("vMonitoreo.msgErrComandArduino"),
                });
              }
            })
            .catch((e) => {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "error",
                title: this.$t("vMonitoreo.msgErrReset"),
              });
            });
        }
      });
    },
    fix() {
      var comando = "fix";
      if (!this.alarma.modoRastreo) {
        comando = "nofix";
      }

      fetch(
        process.env.VUE_APP_URL_SERVER_ARDUINOs +
          this.dispositivo.telefono +
          "," +
          comando +
          this.dispositivo.contrasena
      )
        .then((response) => response.json())
        .then((json) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 5000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "success",
            title: this.$t("configDispositivos.magCambioZona"),
            text: this.$t("vMonitoreo.msgTiempoResp"),
          });
          const io = require("socket.io-client"),
            ioClient = io.connect(
              process.env.VUE_APP_URL_SERVER_SOCKET_ARDUINO
            );

          ioClient.on("sms", (msg) => {
            var trama = Jwt.jwtDecodeSms(msg);
            var num = "",
              b,
              shock;
            for (var i = 0; i < trama.length; i++) {
              if (trama.substring(i, i + 1) == "|") {
                b = i;
              }
            }
            num = trama.substring(0, b - 1);
            shock = trama.substring(b + 1, trama.length);

            if (num == this.dispositivo.telefono) {
              if (shock == "monitorok!" || shock == "monitorok") {
                this.alarma.modoRastreo = false;
              }
              if (shock == "trackerok!" || shock == "trackerok") {
                this.alarma.modoRastreo = true;
              }
            }
          });
        })
        .catch((e) => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: this.$t("configDispositivos.msgErrCambioZona"),
          });
        });
    },
    agregarAdmin() {
      if (this.alarma.inputAdmin != null) {
        if (this.alarma.inputAdmin.length == 10) {
          this.mensajeError = "";
          //fetch(process.env.VUE_APP_URL_SERVER_ARDUINO + this.dispositivo.telefono + ',' + "admin" + this.dispositivo.contrasena + " " + this.alarma.inputAdmin)
          AlarmaSMSDataService.enviar(
            this.dispositivo.telefono +
              "," +
              "admin" +
              this.dispositivo.contrasena +
              " " +
              this.alarma.inputAdmin
          )
            .then((response) => {
              if (response.status == 200) {
                this.accion =
                  "Se configuró un administrador con el número " +
                  this.dispositivo.telefono +
                  " para el dispositivo " +
                  this.dispositivo.nombre;
                this.registrarAccion();
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "success",
                  title: this.$t("configDispositivos.modoConfAdmin"),
                  text: this.$t("vMonitoreo.msgTiempoResp"),
                });
                var data = {
                  id: this.alarma.id,
                  idDispositivo: this.configuracionActual.idDispositivo,
                  alarmaImpacto: this.configuracionActual.alarmaImpacto,
                  apagadoProfundo: this.configuracionActual.apagadoProfundo,
                  modoRastreo: this.configuracionActual.modoRastreo,
                  bateriaBaja: this.configuracionActual.bateriaBaja,
                  alarmaDistancia: this.configuracionActual.alarmaDistancia,
                  distancia: this.configuracionActual.distancia,
                  alarmaVelocidad: this.configuracionActual.alarmaVelocidad,
                  velocidad: this.configuracionActual.velocidad,
                  alarmaSensibilidad:
                    this.configuracionActual.alarmaSensibilidad,
                  nivelSensibilidad: this.configuracionActual.nivelSensibilidad,
                  alarmaDireccion: this.configuracionActual.alarmaDireccion,
                  anguloDireccion: this.configuracionActual.anguloDireccion,
                  alarmaMovimiento: this.configuracionActual.alarmaMovimiento,
                  radio: this.configuracionActual.radio,
                  alarmaTrabajarHorarioEspecifico:
                    this.configuracionActual.alarmaTrabajarHorarioEspecifico,
                  horarioTrabajar: this.configuracionActual.horarioTrabajar,
                  tiempoTrabajo: this.configuracionActual.tiempoTrabajo,
                  dormirTiempo: this.configuracionActual.dormirTiempo,
                  tiempoDormir: this.configuracionActual.tiempoDormir,
                  alarmaApagado: this.configuracionActual.alarmaApagado,
                  tipoApagado: this.configuracionActual.tipoApagado,
                  zonaHoraria: this.configuracionActual.zonaHoraria,
                  listaAdmin: this.listaAdmin,
                  alarmaFix: this.alarma.alarmaFix,
                  tiempoFixMovimiento: this.alarma.tiempoFixMovimiento,
                  tiempoFixEstatico: this.alarma.tiempoFixEstatico,
                  horarioFixMovimiento: this.alarma.horarioFixMovimiento,
                  horarioFixEstatico: this.alarma.horarioFixEstatico,
                };
                sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
                AlarmaSMSDataService.update(data)
                  .then(() => {
                    const Toast2 = this.$swal.mixin({
                      toast: true,
                      position: "top-end",
                      showConfirmButton: false,
                      timer: 4000,
                      timerProgressBar: true,
                      didOpen: (toast) => {
                        toast.addEventListener(
                          "mouseenter",
                          this.$swal.stopTimer
                        );
                        toast.addEventListener(
                          "mouseleave",
                          this.$swal.resumeTimer
                        );
                      },
                    });
                    Toast2.fire({
                      icon: "success",
                      title: this.$t("configDispositivos.msgComandos"),
                      text: this.$t("vMonitoreo.msgTiempoResp"),
                    });
                    //this.$nextTick();
                    this.ObtenerDatos();
                    this.alarma.inputAdmin = null;
                    this.alarma.listaAdmin = this.listaAdmin;
                  })
                  .catch(() => {
                    const Toast = this.$swal.mixin({
                      toast: true,
                      position: "top-end",
                      showConfirmButton: false,
                      timer: 4000,
                      timerProgressBar: true,
                      didOpen: (toast) => {
                        toast.addEventListener(
                          "mouseenter",
                          this.$swal.stopTimer
                        );
                        toast.addEventListener(
                          "mouseleave",
                          this.$swal.resumeTimer
                        );
                      },
                    });

                    Toast.fire({
                      icon: "error",
                      title: this.$t("configDispositivos.msgErrActConfig"),
                    });
                  });

                const io = require("socket.io-client"),
                  ioClient = io.connect(
                    process.env.VUE_APP_URL_SERVER_SOCKET_ARDUINO
                  );
                this.listaAdmin = [];
                if (this.alarma.listaAdmin.length != 0) {
                  var p = 0;
                  for (var i = 0; i < this.alarma.listaAdmin.length; i++) {
                    this.listaAdmin[p] = this.alarma.listaAdmin[i];
                    p++;
                  }
                  this.listaAdmin[p] = this.alarma.inputAdmin;
                } else {
                  this.listaAdmin[0] = this.alarma.inputAdmin;
                }
                var data = {
                  id: this.alarma.id,
                  idDispositivo: this.configuracionActual.idDispositivo,
                  alarmaImpacto: this.configuracionActual.alarmaImpacto,
                  apagadoProfundo: this.configuracionActual.apagadoProfundo,
                  modoRastreo: this.configuracionActual.modoRastreo,
                  bateriaBaja: this.configuracionActual.bateriaBaja,
                  alarmaDistancia: this.configuracionActual.alarmaDistancia,
                  distancia: this.configuracionActual.distancia,
                  alarmaVelocidad: this.configuracionActual.alarmaVelocidad,
                  velocidad: this.configuracionActual.velocidad,
                  alarmaSensibilidad:
                    this.configuracionActual.alarmaSensibilidad,
                  nivelSensibilidad: this.configuracionActual.nivelSensibilidad,
                  alarmaDireccion: this.configuracionActual.alarmaDireccion,
                  anguloDireccion: this.configuracionActual.anguloDireccion,
                  alarmaMovimiento: this.configuracionActual.alarmaMovimiento,
                  radio: this.configuracionActual.radio,
                  alarmaTrabajarHorarioEspecifico:
                    this.configuracionActual.alarmaTrabajarHorarioEspecifico,
                  horarioTrabajar: this.configuracionActual.horarioTrabajar,
                  tiempoTrabajo: this.configuracionActual.tiempoTrabajo,
                  dormirTiempo: this.configuracionActual.dormirTiempo,
                  tiempoDormir: this.configuracionActual.tiempoDormir,
                  alarmaApagado: this.configuracionActual.alarmaApagado,
                  tipoApagado: this.configuracionActual.tipoApagado,
                  zonaHoraria: this.configuracionActual.zonaHoraria,
                  listaAdmin: this.listaAdmin,
                  alarmaFix: this.alarma.alarmaFix,
                  tiempoFixMovimiento: this.alarma.tiempoFixMovimiento,
                  tiempoFixEstatico: this.alarma.tiempoFixEstatico,
                  horarioFixMovimiento: this.alarma.horarioFixMovimiento,
                  horarioFixEstatico: this.alarma.horarioFixEstatico,
                };
                sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
                AlarmaSMSDataService.update(data)
                  .then(() => {
                    const Toast = this.$swal.mixin({
                      toast: true,
                      position: "top-end",
                      showConfirmButton: false,
                      timer: 4000,
                      timerProgressBar: true,
                      didOpen: (toast) => {
                        toast.addEventListener(
                          "mouseenter",
                          this.$swal.stopTimer
                        );
                        toast.addEventListener(
                          "mouseleave",
                          this.$swal.resumeTimer
                        );
                      },
                    });

                    Toast.fire({
                      icon: "success",
                      title: this.$t("configDispositivos.msgConfigExito"),
                    });
                    //this.$nextTick();
                    this.ObtenerDatos();
                    this.alarma.inputAdmin = null;
                    this.alarma.listaAdmin = this.listaAdmin;
                  })
                  .catch(() => {
                    const Toast = this.$swal.mixin({
                      toast: true,
                      position: "top-end",
                      showConfirmButton: false,
                      timer: 4000,
                      timerProgressBar: true,
                      didOpen: (toast) => {
                        toast.addEventListener(
                          "mouseenter",
                          this.$swal.stopTimer
                        );
                        toast.addEventListener(
                          "mouseleave",
                          this.$swal.resumeTimer
                        );
                      },
                    });

                    Toast.fire({
                      icon: "error",
                      title: this.$t("configDispositivos.msgErrActConfig"),
                    });
                  });

                ioClient.on("sms", (msg) => {
                  var trama = Jwt.jwtDecodeSms(msg);
                  var num = "",
                    b,
                    shock;
                  for (var i = 0; i < trama.length; i++) {
                    if (trama.substring(i, i + 1) == "|") {
                      b = i;
                    }
                  }
                  num = trama.substring(0, b - 1);
                  shock = trama.substring(b + 1, trama.length);
                  if (num == this.dispositivo.telefono) {
                    if (shock == "adminok!" || shock == "adminok") {
                      const Toast2 = this.$swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 4000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                          toast.addEventListener(
                            "mouseenter",
                            this.$swal.stopTimer
                          );
                          toast.addEventListener(
                            "mouseleave",
                            this.$swal.resumeTimer
                          );
                        },
                      });

                      Toast2.fire({
                        icon: "success",
                        title: this.$t("configDispositivos.msgAddAdmin"),
                      });
                    }
                    if (shock == "noadminok!" || shock == "noadminok") {
                      const Toast2 = this.$swal.mixin({
                        toast: true,
                        position: "top-end",
                        showConfirmButton: false,
                        timer: 4000,
                        timerProgressBar: true,
                        didOpen: (toast) => {
                          toast.addEventListener(
                            "mouseenter",
                            this.$swal.stopTimer
                          );
                          toast.addEventListener(
                            "mouseleave",
                            this.$swal.resumeTimer
                          );
                        },
                      });

                      Toast2.fire({
                        icon: "success",
                        title: this.$t("configDispositivos.msgDelAdmin"),
                      });
                    }
                  }
                });
              } else {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });
  
                Toast.fire({
                  icon: "error",
                  title: this.$t("vMonitoreo.msgErrComandArduino"),
                });
              }
            })
            .catch((e) => {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "error",
                title: this.$t("configDispositivos.msgErrSolicitud"),
              });
            });
        } else {
          this.mensajeError = this.$t("configDispositivos.msgTelValido");
        }
      } else {
        this.mensajeError = this.$t("configDispositivos.msgAddTel");
      }
    },
    eliminarAdmin(dato) {
      //fetch(process.env.VUE_APP_URL_SERVER_ARDUINO + this.dispositivo.telefono + ',' + "noadmin" + this.dispositivo.contrasena + " " + dato.n)
      this.accion =
        "Se eliminó un administrador con el número " +
        this.dispositivo.telefono +
        " para el dispositivo " +
        this.dispositivo.nombre;
      this.registrarAccion();
      AlarmaSMSDataService.enviar(
        this.dispositivo.telefono +
          "," +
          "noadmin" +
          this.dispositivo.contrasena +
          " " +
          dato.n
      )
        .then((response) => {
          if (response.status == 200) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: this.$t("configDispositivos.msgElimAdmin"),
              text: this.$t("vMonitoreo.msgTiempoResp"),
            });
            const io = require("socket.io-client"),
              ioClient = io.connect(
                process.env.VUE_APP_URL_SERVER_SOCKET_ARDUINO
              );
            this.listaAdmin = [];
            if (this.alarma.listaAdmin.length != 0) {
              var p = 0;
              for (var i = 0; i < this.alarma.listaAdmin.length; i++) {
                if (this.alarma.listaAdmin[i] != dato.n) {
                  this.listaAdmin[p] = this.alarma.listaAdmin[i];
                  p++;
                }
              }
            }
            var data = {
              id: this.alarma.id,
              idDispositivo: this.configuracionActual.idDispositivo,
              alarmaImpacto: this.configuracionActual.alarmaImpacto,
              apagadoProfundo: this.configuracionActual.apagadoProfundo,
              modoRastreo: this.configuracionActual.modoRastreo,
              bateriaBaja: this.configuracionActual.bateriaBaja,
              alarmaDistancia: this.configuracionActual.alarmaDistancia,
              distancia: this.configuracionActual.distancia,
              alarmaVelocidad: this.configuracionActual.alarmaVelocidad,
              velocidad: this.configuracionActual.velocidad,
              alarmaSensibilidad: this.configuracionActual.alarmaSensibilidad,
              nivelSensibilidad: this.configuracionActual.nivelSensibilidad,
              alarmaDireccion: this.configuracionActual.alarmaDireccion,
              anguloDireccion: this.configuracionActual.anguloDireccion,
              alarmaMovimiento: this.configuracionActual.alarmaMovimiento,
              radio: this.configuracionActual.radio,
              alarmaTrabajarHorarioEspecifico:
                this.configuracionActual.alarmaTrabajarHorarioEspecifico,
              horarioTrabajar: this.configuracionActual.horarioTrabajar,
              tiempoTrabajo: this.configuracionActual.tiempoTrabajo,
              dormirTiempo: this.configuracionActual.dormirTiempo,
              tiempoDormir: this.configuracionActual.tiempoDormir,
              alarmaApagado: this.configuracionActual.alarmaApagado,
              tipoApagado: this.configuracionActual.tipoApagado,
              zonaHoraria: this.configuracionActual.zonaHoraria,
              listaAdmin: this.listaAdmin,
              alarmaFix: this.alarma.alarmaFix,
              tiempoFixMovimiento: this.alarma.tiempoFixMovimiento,
              tiempoFixEstatico: this.alarma.tiempoFixEstatico,
              horarioFixMovimiento: this.alarma.horarioFixMovimiento,
              horarioFixEstatico: this.alarma.horarioFixEstatico,
            };
            sessionStorage.setItem("idAlarmaSMS", this.alarma.id);
            AlarmaSMSDataService.update(data)
              .then(() => {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "success",
                  title: this.$t("configDispositivos.msgConfigExito"),
                });
                const Toast2 = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });
                Toast2.fire({
                  icon: "success",
                  title: this.$t("configDispositivos.msgComandos"),
                  text: this.$t("vMonitoreo.msgTiempoResp"),
                });
                this.ObtenerDatos();
                this.alarma.listaAdmin = this.listaAdmin;
                this.alarma.banAdmin = false;
                this.alarma.banAdmin = true;
              })
              .catch(() => {
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 4000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "error",
                  title: this.$t("configDispositivos.msgErrActConfig"),
                });
              });

            ioClient.on("sms", (msg) => {
              var trama = Jwt.jwtDecodeSms(msg);
              var num = "",
                b,
                shock;
              for (var i = 0; i < trama.length; i++) {
                if (trama.substring(i, i + 1) == "|") {
                  b = i;
                }
              }
              num = trama.substring(0, b - 1);
              shock = trama.substring(b + 1, trama.length);
            });
          } else {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: this.$t("vMonitoreo.msgErrComandArduino"),
            });
          }
        })
        .catch(() => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: this.$t("configDispositivos.msgErrDelAdmin"),
          });
        });
    },
    /**
     * Método que envia los comandos de las configuraciones.
     */
    enviarComando(comando, mensaje) {
      for (var i in comando) {
        var a = comando[i];
        var m = mensaje[i];
        this.accion = m;
        this.registrarAccion();
        AlarmaSMSDataService.enviar(a)
          .then((response) => {
            if (response.status == 200) {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 5000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "success",
                title: this.$t("configDispositivos.msgComandos"),
                text: this.$t("vMonitoreo.msgTiempoResp"),
              });
            } else {
              const Toast = this.$swal.mixin({
                toast: true,
                position: "top-end",
                showConfirmButton: false,
                timer: 4000,
                timerProgressBar: true,
                didOpen: (toast) => {
                  toast.addEventListener("mouseenter", this.$swal.stopTimer);
                  toast.addEventListener("mouseleave", this.$swal.resumeTimer);
                },
              });

              Toast.fire({
                icon: "error",
                title: this.$t("vMonitoreo.msgErrComandArduino"),
              });
            }
          })
          .catch(() => {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: this.$t("vMonitoreo.msgErrComandArduino"),
            });
          });
      }
    },
    /**
     * Método para el envio de vefirifcar estatus del dispositivo.
     */
    enviarCheck() {
      this.accion =
        "Solicitud de estatus del dispositivo " +
        this.dispositivo.nombre +
        " con el número " +
        this.dispositivo.telefono;
      this.registrarAccion();
      AlarmaSMSDataService.enviar(
        this.dispositivo.telefono + "," + "check123456"
      )
        .then((response) => {
          if (response.status == 200) {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 5000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "success",
              title: this.$t("configDispositivos.msgSolicitudEstatus"),
              text: this.$t("vMonitoreo.msgTiempoResp"),
            });
            const io = require("socket.io-client"),
              ioClient = io.connect(
                process.env.VUE_APP_URL_SERVER_SOCKET_ARDUINO
              );

            ioClient.on("sms", (msg) => {
              var trama = Jwt.jwtDecodeSms(msg);
              var power,
                bat,
                gprs,
                gps,
                gsm,
                ip,
                apn,
                shock,
                b,
                a,
                ipp,
                gsmI,
                batI,
                gpsI,
                shockI;
              if (trama.substring(12, 13) == "P") {
                for (var i = 0; i < trama.length; i++) {
                  if (trama.substring(i, i + 1) == "%") {
                    b = i;
                  }
                  if (trama.substring(i, i + 1) == "A") {
                    a = i;
                  }
                  if (trama.substring(i, i + 1) == "I") {
                    ipp = i;
                  }
                  if (trama.substring(i, i + 3) == "GSM") {
                    gsmI = i;
                  }
                  if (trama.substring(i, i + 4) == "Bat:") {
                    batI = i;
                  }
                  if (trama.substring(i, i + 4) == "GPS:") {
                    gpsI = i;
                  }
                  if (trama.substring(i, i + 6) == "Shock:") {
                    shockI = i;
                  }
                }
                //Power
                if (trama.substring(19, 20) == "F") {
                  //off
                  power = "Power: " + trama.substring(18, 21);
                  if (trama.substring(25, 26) == "1") {
                    //bateria
                    bat = "Batería: " + trama.substring(batI + 4, b + 1);
                    //GPSR
                    gprs = "GPRS: " + trama.substring(b + 6, gpsI);
                    //GPS
                    gps = "GPS: " + trama.substring(gpsI + 4, gsmI);
                    //GSM
                    gsm = "GSM: " + trama.substring(gsmI + 4, a);
                    //APN
                    apn = "APN: " + trama.substring(a + 4, ipp);
                    //IP
                    ip = "IP: " + trama.substring(ipp + 3, shockI);
                    //shock
                    shock =
                      "shock:" + trama.substring(shockI + 6, trama.length);
                  } else {
                    //bateria
                    bat = "Batería: " + trama.substring(batI + 4, b + 1);
                    //GPSR
                    gprs = "GPRS: " + trama.substring(b + 6, gpsI);
                    //GPS
                    if (trama.substring(39, 40) == "O") {
                      gps = "GPS: " + trama.substring(gpsI + 4, gsmI);
                    } else {
                      gps = "GPS: " + trama.substring(gpsI + 4, gsmI);
                    }
                    //GSM
                    gsm = "GSM: " + trama.substring(gsmI + 4, a);
                    //APN
                    apn = "APN: " + trama.substring(a + 4, ipp);
                    //IP
                    ip = "IP: " + trama.substring(ipp + 3, shockI);
                    //shock
                    shock =
                      "shock:" + trama.substring(shockI + 6, trama.length);
                  }
                } else {
                  power = "Power: " + trama.substring(18, 20);
                  //bateria
                  bat = "Batería: " + trama.substring(batI + 4, b + 1);
                  //GPRS
                  gprs = "GPRS: " + trama.substring(b + 6, gpsI);
                  //GPS
                  gps = "GPS: " + trama.substring(gpsI + 4, gsmI);
                  //GSM
                  gsm = "GSM: " + trama.substring(gsmI + 4, a);
                  //APN
                  apn = "APN: " + trama.substring(a + 4, a + 31);
                  //IP
                  ip = "IP: " + trama.substring(ipp + 3, shockI);
                  //shock
                  shock = "shock:" + trama.substring(shockI + 6, trama.length);
                }

                document.getElementById("textarea").value =
                  power +
                  "\n" +
                  bat +
                  "\n" +
                  gprs +
                  "\n" +
                  gps +
                  "\n" +
                  gsm +
                  "\n" +
                  apn +
                  "\n" +
                  ip +
                  "\n" +
                  shock;
                sessionStorage.setItem(
                  "check",
                  power +
                    "\n" +
                    bat +
                    "\n" +
                    gprs +
                    "\n" +
                    gps +
                    "\n" +
                    gsm +
                    "\n" +
                    apn +
                    "\n" +
                    ip +
                    "\n" +
                    shock
                );
                sessionStorage.setItem("DisCheck", this.dispositivo.nombre);
                const Toast = this.$swal.mixin({
                  toast: true,
                  position: "top-end",
                  showConfirmButton: false,
                  timer: 5000,
                  timerProgressBar: true,
                  didOpen: (toast) => {
                    toast.addEventListener("mouseenter", this.$swal.stopTimer);
                    toast.addEventListener(
                      "mouseleave",
                      this.$swal.resumeTimer
                    );
                  },
                });

                Toast.fire({
                  icon: "success",
                  title: this.$t("configDispositivos.msgRespuestaSolicitud"),
                });
              }
            });
          } else {
            const Toast = this.$swal.mixin({
              toast: true,
              position: "top-end",
              showConfirmButton: false,
              timer: 4000,
              timerProgressBar: true,
              didOpen: (toast) => {
                toast.addEventListener("mouseenter", this.$swal.stopTimer);
                toast.addEventListener("mouseleave", this.$swal.resumeTimer);
              },
            });

            Toast.fire({
              icon: "error",
              title: this.$t("vMonitoreo.msgErrComandArduino"),
            });
          }
        })
        .catch(() => {
          const Toast = this.$swal.mixin({
            toast: true,
            position: "top-end",
            showConfirmButton: false,
            timer: 4000,
            timerProgressBar: true,
            didOpen: (toast) => {
              toast.addEventListener("mouseenter", this.$swal.stopTimer);
              toast.addEventListener("mouseleave", this.$swal.resumeTimer);
            },
          });

          Toast.fire({
            icon: "error",
            title: this.$t("configDispositivos.msgErroEstatus"),
          });
        });
    },
    registrarAccion() {
      var data = {
        usuario: this.usuarioLogueado,
        accion: this.accion + sessionStorage.infoDevice,
        fechaCreacion: new Date(),
        tipo: "configuracion",
      };
      AccionesDataService.create(data);
    },
    validaciones() {
      return !this.phoneState;
    },
    getModelo() {
      if (this.dispositivo.model) return this.dispositivo.model.modelo;
      else return this.$t("configDispositivos.noAsignado");
    },
  },
};
</script>

<style scoped>
.alineado-titulo-form {
  text-align: start;
}

#txtAlign {
  text-align: center;
}

.ancho-icono-boton {
  max-width: 80px;
}

@media (max-width: 991px) {
  .ancho-icono-boton {
    width: 50px !important
  }
}

@media (max-width: 959px) {
  .margin-top-div {
    margin-top: -22px;
  }
}

@media (min-width: 960px) {
  .margin-top-div {
    margin-top: 0px;
  }
}

@media (min-width: 992px) {
  .ancho-boton {
    width: 200px;
  }
}

@media (min-width: 1200px) {
  .ancho-boton {
    width: 300px !important;
  }
}

@media (max-width: 991.98px) and (max-height: 950px) {
  #txtAlign {
    text-align: center;
  }
}

.layered.box {
  box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075),
    0 2px 2px hsl(0deg 0% 0% / 0.075), 0 4px 4px hsl(0deg 0% 0% / 0.075),
    0 8px 8px hsl(0deg 0% 0% / 0.075), 0 16px 16px hsl(0deg 0% 0% / 0.075);
}

.box {
  border-radius: 8px;
  background-color: white;
}

.layered2.box2 {
  box-shadow: 0 1px 1px hsl(0deg 0% 0% / 0.075),
    0 2px 2px hsl(0deg 0% 0% / 0.075), 0 4px 4px hsl(0deg 0% 0% / 0.075),
    0 8px 8px hsl(0deg 0% 0% / 0.075), 0 16px 16px hsl(0deg 0% 0% / 0.075);
}

.box2 {
  border-radius: 8px;
}
</style>
